import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, Eye, ArrowUpRight } from 'lucide-react';

const RecentVendors = ({ vendors = [] }) => {
 const navigate = useNavigate();

 const formatDate = (dateString) => {
 if (!dateString) return 'N/A';
 return new Date(dateString).toLocaleDateString('en-US', {
 month: 'short',
 day: 'numeric',
 year: 'numeric',
 });
 };

 const getVendorName = (vendor) => {
 return (
 vendor.vendorProfile?.business_name ||
 (vendor.first_name && vendor.last_name
 ? `${vendor.first_name} ${vendor.last_name}`
 : null) ||
 vendor.name ||
 vendor.email?.split('@')[0] ||
 'Unknown vendor'
 );
 };

 const getVendorDate = (vendor) => {
 return vendor.created_at || vendor.vendorProfile?.created_at;
 };

 return (
 <div className="product-panel overflow-hidden">
 <div className="flex items-center justify-between gap-3 px-4 sm:px-5 pt-4 sm:pt-5 pb-3">
 <div>
 <h2 className="text-base font-semibold text-ink">Recent vendors</h2>
 <p className="text-xs text-ink-tertiary mt-0.5">Newly joined businesses</p>
 </div>
 <button
 type="button"
 onClick={() => navigate('/admin/vendors')}
 className="text-sm text-ink hover:text-ink font-medium inline-flex items-center gap-1 shrink-0"
 >
 View all
 <ArrowUpRight className="w-4 h-4" />
 </button>
 </div>

 {vendors.length > 0 ? (
 <div className="divide-y divide-gray-100">
 {vendors.slice(0, 5).map((vendor) => (
 <div
 key={vendor.id}
 role="button"
 tabIndex={0}
 onClick={() => navigate(`/admin/vendors/${vendor.id}`)}
 onKeyDown={(e) => {
 if (e.key === 'Enter' || e.key === ' ') {
 e.preventDefault();
 navigate(`/admin/vendors/${vendor.id}`);
 }
 }}
 className="flex items-center justify-between gap-3 px-4 sm:px-5 py-3.5 hover:bg-surface-muted/80 cursor-pointer transition-colors"
 >
 <div className="flex items-center gap-3 flex-1 min-w-0">
 <div className="w-9 h-9 bg-gray-100 rounded-xl flex items-center justify-center flex-shrink-0">
 <Building2 className="w-4 h-4 text-ink-secondary" />
 </div>
 <div className="min-w-0 flex-1">
 <p className="text-sm font-semibold text-ink truncate">
 {getVendorName(vendor)}
 </p>
 <p className="text-xs text-ink-tertiary">
 Joined {formatDate(getVendorDate(vendor))}
 </p>
 </div>
 </div>
 <Eye className="w-4 h-4 text-gray-400 flex-shrink-0" />
 </div>
 ))}
 </div>
 ) : (
 <div className="text-center py-14 px-6">
 <Building2 className="w-9 h-9 text-gray-300 mx-auto mb-3" />
 <p className="text-sm font-medium text-ink">No recent vendors</p>
 <p className="text-xs text-ink-tertiary mt-1">New vendor accounts will appear here.</p>
 </div>
 )}
 </div>
 );
};

export default RecentVendors;
